var custom_cursor_default = (() => {
    if (!customElements.get("custom-cursor")) {
        const GLOBAL_OFFSET_X = 0;
        const GLOBAL_OFFSET_Y = 0;
        customElements.define("custom-cursor", class CustomCursor extends HTMLElement {
            cursor=this.querySelector("div");
            target=this.dataset.target;
            hoverMQ=window.matchMedia("(hover: none)");
            offsetX=parseFloat(this.dataset.offsetX);
            offsetY=parseFloat(this.dataset.offsetY);
            constructor() {
                super();
                this.onMouseEnter = event => this.on(event.target, event);
                this.onMouseMove = event => this.on(event.target, event);
                this.onMouseLeave = event => this.off(event.target);
            }
            on(el, event) {
                const videoPlayerEl = el.closest("video-player");
                if (videoPlayerEl && !videoPlayerEl?.querySelector("video")?.paused) return;
                const x = event.clientX + (isNaN(this.offsetX) ? GLOBAL_OFFSET_X : this.offsetX);
                const y = event.clientY + (isNaN(this.offsetY) ? GLOBAL_OFFSET_Y : this.offsetY);
                this.cursor.style.left = `${x}px`;
                this.cursor.style.top = `${y}px`;
                this.cursor.classList.remove("scale-0");
            }
            off(el) {
                this.cursor.classList.add("scale-0");
            }
            bind() {
                (this.closest(".shopify-section") || document.body).querySelectorAll(this.target).forEach(el => {
                    el.addEventListener("mouseenter", this.onMouseEnter);
                    el.addEventListener("mousemove", this.onMouseMove, {
                        passive: true
                    });
                    el.addEventListener("mouseleave", this.onMouseLeave);
                });
            }
            addEventListeners() {
                if (this.cursor && this.target) this.bind();
            }
            removeEventListeners() {
                (this.closest(".shopify-section") || document.body).querySelectorAll(this.target).forEach(el => {
                    el.removeEventListener("mouseenter", this.onMouseEnter);
                    el.removeEventListener("mousemove", this.onMouseMove, {
                        passive: true
                    });
                    el.removeEventListener("mouseleave", this.onMouseLeave);
                });
                if (this.cursor) this.cursor.classList.add("scale-0");
            }
            connectedCallback() {
                this.offsetX = parseFloat(this.dataset.offsetX ?? GLOBAL_OFFSET_X);
                this.offsetY = parseFloat(this.dataset.offsetY ?? GLOBAL_OFFSET_Y);
                this.handleHoverChange = e => e.matches ? this.removeEventListeners() : this.addEventListeners();
                if (!this.hoverMQ.matches) this.addEventListeners();
                this.hoverMQ.addEventListener("change", this.handleHoverChange);
            }
            disconnectedCallback() {
                this.removeEventListeners();
                this.hoverMQ.removeEventListener("change", this.handleHoverChange);
            }
        });
    }
})();